export default __webpack_public_path__ + "static/media/twitter-icon.7af43dae.svg";